import styles from './videojocs.module.scss';
import Fila from 'components/corporatiu/Fila';
import PreguntesFrequents from 'components/corporatiu/PreguntesFrequents';
import Capcalera from './Capcalera';
import Joc from './Joc';
import PremisLudi from './PremisLudi';
import ElsnostresJocs from './ElsnostresJocs';

export default function Videojocs({ jocs, preguntesFrequents }) {
    return (
        <>
            <div className={styles.fons}>
                <Capcalera />
                <Fila tipus='fixed'>
                    {Array.isArray(jocs) &&
                        jocs.map((joc, index) => (
                            <Joc
                                key={joc?.id ?? joc?.titol ?? index}
                                titol={joc?.titol}
                                background={joc?.background}
                                logo={joc?.logo}
                                tags={joc?.tags}
                                entradeta={joc?.entradeta}
                                plataformes={joc?.plataformes}
                                demo={joc?.demo}
                                mesinfo={joc?.mesinfo}
                                video={joc?.video}
                                screenshots={joc?.screenshots}
                            />
                        ))}
                </Fila>
                <Fila tipus='fixed'>
                    <PremisLudi
                        titol="Suma't a la comunitat dels Premis Ludi"
                        text='Els premis que reconeixen el talent jove de Catalunya en la creació de videojocs'
                        textBoto='Més informació'
                        imgFons='https://img.3cat.cat/multimedia/jpg/1/9/1778748331391.jpg'
                    />
                </Fila>
                <ElsnostresJocs />
            </div>
            <Fila tipus='fixed'>
                <PreguntesFrequents titol={preguntesFrequents?.titol} preguntes={preguntesFrequents?.preguntes} />
            </Fila>
        </>
    );
}
